import React, { useEffect } from "react";
import { useFormik } from "formik";
import api from "api";
import { popinfo } from "component/Fancybox/Fancybox";
import { useState } from "react";
import { connect } from "react-redux";
import fancybox from "component/Fancybox/Fancybox";
import BlockHeader from "component/BlockHeader/BlockHeader";
import ExperienceMedia from "component/EditExperienceMedia";
import { format } from 'date-fns';
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import {
    DndContext, 
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
  } from '@dnd-kit/core';
  import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
  } from '@dnd-kit/sortable';

import MediaItem from "./media-item";


import _ from "lodash";
import "./style.scss";


const EditExperience = connect(stateMap)((props) => {
    const [experience, setExperience] = useState(props.experience);

    const months = ['Select Month', 'Januari', 'Februari', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const [medias, setMedias] = useState([]);

    const formik = useFormik({
        initialValues : {
            ExpTitle    : experience ? experience.ExpTitle : ''
            ,ExpStartMonth    : experience ? experience.ExpStartMonth : ''
            ,ExpStartYear    : experience ? experience.ExpStartYear : ''
            ,ExpEndMonth    : experience ? experience.ExpEndMonth : ''
            ,ExpEndYear    : experience ? experience.ExpEndYear : ''
            ,ExpIsCurrent    : experience ? experience.ExpIsCurrent : 0
            ,ExpDesc    : experience ? experience.ExpDesc : ''
            ,ExpID      : experience ? experience.ExpID : 0
            ,ExpDate    : format(new Date(), 'y-MM-dd')
            ,ExpMedias  : []
        }
        ,onSubmit : (values) => {
            
            let savingInterest = popinfo('loading', 'Saving Experience', 'Enter your interesting work experience <br/> and impress anyone who looks at your profile')

            api('/Profile/Experience', 'post', _.extend({}, values, {
                ExpMedias : _.filter(medias, (media) => {
                    return parseInt(media.isDeleted) === 0;
                }) 
            }), 'Bearer ' + props.auth.token)
                .then((response) => {

                    if(response.mediaErr.length)
                    {
                        popinfo('error', 'Experience Saved', 'Some of the media failed to save', {}, savingInterest)
                    }
                    else
                    {
                        savingInterest.close();
                    }

                    props.onSubmit.apply(null, [response.experience]);

                })
                .catch(error => {
                    popinfo('error', 'Saving Experience', error, {}, savingInterest)
                })
        }
    })

    const settingFormValues = () => {
        _.each(experience, (value, attribute) => {
            if(value === null)
            {
                value = '';
            }

            if( attribute == 'ExpDate' && value == '')
            {
                
                value = format(new Date(), 'y-MM-dd');
            }
            
            formik.setFieldValue(attribute, value);

        });


        if(!_.isUndefined(experience))
        {
            setMedias(experience.ExpMedias);
        }
    }

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
          coordinateGetter: sortableKeyboardCoordinates,
        })
      );

    useEffect(settingFormValues, [props.experience]);

    return (
        <div className="w-640">
            <form action="" className="generic-form" onSubmit={formik.handleSubmit}>
                <div className="form-group">
                    <label htmlFor="exp-title">Experience Title*</label>
                    <input 
                        type="text" 
                        className="form-control text" 
                        name="ExpTitle" 
                        value={formik.values.ExpTitle}  
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </div>
                <div className="form-group">
                    <div className="config-fields">
                        <div className="field-label">
                            I am currently working on this activity
                        </div>
                        <div className="field-value">
                            <label className="switch-button">
                                <input 
                                    type="checkbox"
                                    checked={formik.values.ExpIsCurrent == 1}
                                    onChange={() => {
                                        
                                        formik.setFieldValue('ExpIsCurrent', formik.values.ExpIsCurrent == 1 ? 0 : 1)
                                    }}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div>
                        <h2 className="field-label">Start Date*</h2>
                        <div className="form-group flex-flat mt-md">
                            <div>
                                <label htmlFor="exp-title">Month</label>
                                <div className="fancy-select">
                                    <select value={formik.values.ExpStartMonth} name="ExpStartMonth" onChange={formik.handleChange}   >
                                        {
                                            months.map((month, monthValue) => (
                                                <option value={monthValue} key={monthValue}>{month}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div>
                                <label htmlFor="exp-title">Year</label>
                                <div className="fancy-select">
                                    <select value={formik.values.ExpStartYear} name="ExpStartYear" onChange={formik.handleChange}  >
                                        <option value="">Select Year</option>
                                        {
                                            _.range(new Date().getFullYear(), 1960).map((year) => (
                                                <option value={year} key={year}>{year}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-md">
                        <h2 className="field-label">End Date</h2>
                        <div className="form-group flex-flat mt-md">
                            <div>
                                <label htmlFor="exp-title">Month</label>
                                <div className="fancy-select">
                                    <select value={formik.values.ExpEndMonth} name="ExpEndMonth" onChange={formik.handleChange} disabled={formik.values.ExpIsCurrent == 1} >
                                        {
                                            months.map((month, monthValue) => (
                                                <option value={monthValue} key={monthValue}>{month}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div>
                                <label htmlFor="exp-title">Year</label>
                                <div className="fancy-select">
                                    <select value={formik.values.ExpEndYear} name="ExpEndYear" onChange={formik.handleChange} disabled={formik.values.ExpIsCurrent == 1} >
                                        <option value="">Select Year</option>
                                        {
                                            _.range(new Date().getFullYear(), 1960).map((year) => (
                                                <option value={year} key={year}>{year}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group mt-md">
                    <label htmlFor="exp-title">Description*</label>
                    <textarea  
                        className="form-control textarea" 
                        name="ExpDesc" 
                        value={formik.values.ExpDesc}  
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="exp-title">Media</label>
                    <span className="block text-xs mb-md">Add documents, photos, sites, videos, and presentations.</span>

                    <div className="experiences-medias">
                        <DndContext 
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={(event)=>{
                                const {active, over} = event;

                                if (active.id !== over.id) 
                                {
                                    setMedias((medias) => {
                                        const oldIndex = medias.indexOf(active.id);
                                        const newIndex = medias.indexOf(over.id);
                                        
                                        return arrayMove(medias, oldIndex, newIndex);
                                    });
                                }
                            }}
                        >
                            <SortableContext 
                                items={medias}
                                strategy={verticalListSortingStrategy}>
                                {
                                    medias.map(media => <MediaItem 
                                        key={media.ExpMediaURL} 
                                        media={media} 
                                        onClickDelete={(media) => {
                                            
                                            setMedias(
                                                update(medias, {
                                                    [_.findIndex(medias, {ExpMediaURL : media.ExpMediaURL})] : {
                                                        isDeleted : {
                                                            $set : 1
                                                        }
                                                    }
                                                })
                                            );

                                        }}
                                    />)
                                }
                            </SortableContext>
                        </DndContext>
                    </div>



                    <a href="#" className="btn btn-reverse btn-mini" onClick={(e) => {
                        e.preventDefault();

                        const ExperienceMediaForm = fancybox(
                            <>
                                <div className="w-640">
                                    <BlockHeader title="Experience Media" desc="Add your experience media" className="mb-sm"/>
                                    <ExperienceMedia onSaved={media => {

                                        setMedias(update(medias, {
                                            $push : [media]
                                        }));

                                        ExperienceMediaForm.close();

                                    }}/>
                                </div>
                            </>
                        );
                    }}>Add Media</a>
                </div>
                <div className="form-group text-right">
                    <input className="btn btn-orange" value="Save" type="submit"/>
                </div>
            </form>
        </div>
    )
})

export { EditExperience }